var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-element-loading',{staticClass:"loader",attrs:{"active":_vm.loading,"spinner":"spinner","color":"#FE4123"}})}
var staticRenderFns = []

export { render, staticRenderFns }